module.exports = __webpack_public_path__ + "img/viewhisticon.ef904ffc.svg";